import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { FileMultiUploaderEntity, MaxLength, ToFormControls } from '@rp/shared/models';

import { FileUploaderComponent } from '../file-uploader.component';
import { IconComponent, IconName } from '../../icon';
import { FileUploaderAcceptFileType } from '../models';
import { addFile } from '../utils';

@Component({
  selector: 'rp-multi-file-uploader',
  standalone: true,
  templateUrl: './multi-file-uploader.component.html',
  styleUrl: './multi-file-uploader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FileUploaderComponent, IconComponent, TranslateModule, ReactiveFormsModule],
})
export class MultiFileUploaderComponent {
  formArray = input.required<FormArray<FormGroup<ToFormControls<FileMultiUploaderEntity>>>>();
  acceptTypes = input(FileUploaderAcceptFileType.DOCUMENT);
  acceptTypesHint = input('pdf, doc(x), xls(x), csv, jpeg, png  <br>');
  allowFileReplace = input(false, { transform: booleanAttribute });
  required = input(false, { transform: booleanAttribute });
  maxSize = input('10Mb');
  maxFileNameLength = input(MaxLength);

  eyeIconClicked = output<number>();

  readonly iconName = IconName;

  onAddFile(): void {
    this.formArray().push(addFile(null, this.required() ? Validators.required : null));
  }

  onRemoveFile(index: number): void {
    this.formArray().removeAt(index);
  }
}
